export default __webpack_public_path__ + "static/media/P-033.7607ffdf.png";